import styled from '@emotion/styled';
import { Typography } from '@material-ui/core';
import { TypographyProps } from '@material-ui/core/Typography';
import { createElement, MouseEvent, MouseEventHandler } from 'react';

import theme from '../../../theme';
import { Consumer as HistoryConsumer } from '../../context/history';

type Props = TypographyProps & {
  href: string;
  onClick?: MouseEventHandler<HTMLAnchorElement>;
  withNewTab?: boolean;
  className?: string;
};

const AnchorTypography = ({ href, withNewTab, onClick, className, ...otherProps }: Props) => (
  <HistoryConsumer>
    {(history) => (
      <Root
        {...(otherProps as any)}
        component="a"
        href={href}
        target={withNewTab ? '_blank' : undefined}
        rel={withNewTab ? 'noopener' : undefined}
        onClick={(e: MouseEvent<HTMLElement>) => {
          if (e.metaKey || e.altKey || e.ctrlKey || e.shiftKey) return;
          if (href.startsWith('http')) return;

          e.preventDefault();

          history.push(href);

          if (onClick) onClick(e);
        }}
        className={className}
      />
    )}
  </HistoryConsumer>
);

const Root = styled(Typography)({
  color: theme.palette.primary.main,
  textDecoration: 'none',
  '&:hover': {
    color: theme.palette.primary.main,
    textDecoration: 'underline',
  },
  '&:active': {
    color: theme.palette.primary.main,
  },
  '&:visited': {
    color: theme.palette.primary.main,
  },
});

export default AnchorTypography;
